import { withSearch } from '@elastic/react-search-ui';
import MultiSelectDropDownFilter from '../../../components/filter/MultiSelectDropDownFilter';

function HeritageGatewayDatasetFilter({
  setFilter,
  removeFilter,
  facets,
  filters,
  addFilter,
}) {
  return (
    <MultiSelectDropDownFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="dataset"
      filters={filters}
      id="dataset"
      label="Dataset"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(
  ({ setFilter, removeFilter, facets, filters, addFilter }) => ({
    setFilter,
    removeFilter,
    facets,
    filters,
    addFilter,
  }),
)(HeritageGatewayDatasetFilter);
